<template>
  <div class="pix-step--wrapper">
    <div class="pix-step">
      <div class="step-number">1</div>
      Abra seu aplicativo financeiro de preferência.
    </div>
    <div class="pix-step mt-20 mb-20">
      <div class="step-number">2</div>
      Escaneie o código QR ao lado ou copie e cole o código para realizar o pagamento.
    </div>
    <div class="pix-step">
      <div class="step-number">3</div>
      Revise os dados informados e aguarde a confirmação. Pronto!
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulletList',
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';
  .pix-step {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    font-family: var(--font-family);
    color: var(--gray-500);

    display: flex;
    gap: 12px;

    @media (min-width: $lg) {
      font-size: 14px;
    }

    .step-number {
      @extend .body-semi-bold;
      font-family: var(--font-family);
      line-height: 20px;
      font-size: 14px;
      color: var(--gray-500);
      background-color: $gray-200;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin-top: 3px;

      width: 20px;
      min-width: 20px;
      height: 20px;
      min-height: 20px;
    }
  }
  .pix-step--wrapper {
    margin-bottom: 20px;
  }
</style>
